import { get } from "lodash";
import { reqSwgUser } from "../../../../api";
import Cookies from "universal-cookie";
const cookies = new Cookies();

/**
 * Helps demonstrate metering functionality.
 *
 * Publishers shouldn't use these values in production. Instead, they should
 * define their own JS and backend code to provide the same functionality securely.
 */
export const MeteringDemo = {
  /** Google Sign-In Client ID for the metering demo. */
  GOOGLE_SIGN_IN_CLIENT_ID: "962641865525-qk3eqej1shfi589ahq1enclp2i5soen0.apps.googleusercontent.com",

  /** URL of iframe containing a Google Sign-In button. */
  GOOGLE_SIGN_IN_IFRAME_URL: "https://www.vikatan.com/registration_widget",

  /** Resets the metering demo. */
  resetMeteringDemo: () => {
    // Forget the existing PPID.
    delete global.localStorage.meteringId;

    // Forget the existing registration timestamp.
    delete global.localStorage.meteringRegistrationTimestamp;

    // Delete the existing username.
    delete global.localStorage.meteringUsername;
  },

  /**
   * Mocks registration of a user, given data from Google Sign-In.
   *
   * This is suitable for a demo. For real integrations, we
   * advise setting a 1st party, secure, HTTP-only cookie,
   * so it lives past 7 days in Safari.
   * https://webkit.org/blog/10218/full-third-party-cookie-blocking-and-more/
   */
  registerUser: gaaUser => {
    let email = get(gaaUser, ["email"], "");
    let auth = get(gaaUser, ["authorizationData", "access_token"], "");
    reqSwgUser(email, auth).then(res => {
      let id = get(res, ["metering", "state", "id"], "");
      let timeStamp = get(res, ["metering", "state", "standardAttributes", "registered_user", "timestamp"], "");
      cookies.set("meteringId", id, { path: "/", domain: ".vikatan.com" });
      cookies.set("meteringUsername", gaaUser.name, { path: "/", domain: ".vikatan.com" });
      cookies.set("meteringRegistrationTimestamp", timeStamp, { path: "/", domain: ".vikatan.com" });

      const logInCookie = get(res, ["cookies"], []);
      logInCookie.map(item => {
        cookies.set(item.key, item.value, { path: "/", domain: ".vikatan.com" });
      });
      global && global.location.reload();
    });
  },

  /** Opens the paywall for demo purposes. */
  openPaywall: () => {
    document.documentElement.classList.add("open-paywall");
  },

  /** Returns the user's metering state, including when the user registered. */
  fetchMeteringState: () => {
    // Logs the username, for the metering demo.
    if (cookies.get("vuid")) {
      console.log(`👋 Hello Cookie, ${cookies.get("meteringUsername")}!`);

      return Promise.resolve({
        id: cookies.get("vuid"),
        registrationTimestamp: cookies.get("meteringRegistrationTimestamp")
      });
    } else {
      return Promise.resolve({
        registrationTimestamp: null
      });
    }
  }
};
